import React from 'react'
import cx from 'classnames'
import { Button, Modal, Input } from '@driftt/tide-core-legacy'

import './style.styl'

class EmailTemplateModal extends React.Component {
  constructor(props) {
    super(props)
    const { settingName, editingAssistantAgentSettings } = this.props
    this.state = {
      [settingName]: editingAssistantAgentSettings.get(settingName),
      selectedSetting: settingName
    }
    if (settingName === 'MEETING_CANCELLED') {
      this.state.MEETING_RESCHEDULED = editingAssistantAgentSettings.get('MEETING_RESCHEDULED')
    }
  }
  render() {
    const { onSave, onCancel, settingName } = this.props
    const selectedSetting = this.state[this.state.selectedSetting]
    const emailSubject = selectedSetting.get('emailSubject')
    const emailBody = selectedSetting.get('emailBody')
    const hasTemplateOptions = settingName === 'MEETING_CANCELLED'

    return <Modal
      open={true}
      size="medium"
      onClose={onCancel}
    >
      <div className="email-template-modal-content">
        <div className="email-template-modal-header">
          <h2>Customize your follow up templates</h2>
          <p>When you click to “Follow up with an email” from the reminder email, this is the default template we’ll use to pre-populate your follow-up email. You can customize it below.</p>
        </div>
        {hasTemplateOptions && <div className="template-options-wrapper">
          <p
            className={cx("template-option", { selected: this.state.selectedSetting === 'MEETING_CANCELLED' })}
            onClick={() => this.setState({ selectedSetting: 'MEETING_CANCELLED' })}>
            Canceled
          </p>
          <p
            className={cx("template-option", { selected: this.state.selectedSetting === 'MEETING_RESCHEDULED' })}
            onClick={() => this.setState({ selectedSetting: 'MEETING_RESCHEDULED' })}>
            Rescheduled
          </p>
          </div>
        }
        <div className="email-template-modal-body">
          {hasTemplateOptions && <p className="template-helper-copy" >This template can be used to follow up after a <b>{
            this.state.selectedSetting === 'MEETING_CANCELLED' ? 'canceled meeting' : 'rescheduled meeting'
          }.</b></p>}
          <div className="template-label-option-wrapper">
            <p>Email Subject</p>
            <Input
              value={emailSubject || ''}
              onChange={(event) => {
                const newSetting = selectedSetting.set('emailSubject', event.target.value)
                return this.setState({ [this.state.selectedSetting]: newSetting })
              }}
            />
          </div>
          <div className="template-label-option-wrapper">
            <p>Email Template</p>
            <textarea
              value={emailBody || ''}
              onChange={(event) => {
                const newSetting = selectedSetting.set('emailBody', event.target.value)
                return this.setState({ [this.state.selectedSetting]: newSetting })
              }} />
          </div>
        </div>
        <div className="email-template-modal-button-section">
          <Button
            type="primary"
            size="medium"
            onClick={() => onSave(this.state)}
          >
            Save
              </Button>
          <Button
            type="tertiary"
            onClick={onCancel}
          >
            Cancel
              </Button>
        </div>
      </div>
    </Modal>
  }
}

export default EmailTemplateModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfig/MeetingTaskConfig/EmailTemplateModal/index.js